<!-- Общая подпись пункта меню с опциональной временной плашкой new. -->
<template>
  <span v-if="!collapsed" class="sidebar-item-label">
    <span class="sidebar-item-label__text">{{ label }}</span>
    <AppSidebarNewBadge v-if="showNewBadge" />
  </span>
  <AppSidebarNewBadge
    v-else-if="showNewBadge"
    collapsed
  />
</template>

<script>
import AppSidebarNewBadge from "@/components/AppSidebar/NewBadge.vue";

export default {
  name: "AppSidebarItemLabel",

  components: {
    AppSidebarNewBadge,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    showNewBadge: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.sidebar-item-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  padding: 12px 0 12px 10px;
  color: var(--color-light);
  user-select: none;
}

.sidebar-item-label__text {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
